import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "h-100 p-4 py-5" };
const _hoisted_2 = {
    id: "configuratorStartBox",
    class: "w-100 d-flex align-items-center justify-content-center"
};
const _hoisted_3 = { class: "rounded p-5 shadow-sm bg-light m-3 m-md-5" };
const _hoisted_4 = {
    class: "nav nav-underline mb-5",
    role: "tablist"
};
const _hoisted_5 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_6 = {
    class: "nav-link active",
    id: "start-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#start",
    type: "button",
    role: "tab",
    "aria-controls": "start",
    "aria-selected": "true"
};
const _hoisted_7 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_8 = {
    class: "nav-link",
    id: "load-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#load",
    type: "button",
    role: "tab",
    "aria-controls": "load",
    "aria-selected": "false"
};
const _hoisted_9 = { class: "tab-content" };
const _hoisted_10 = {
    class: "tab-pane fade show active",
    id: "start",
    role: "tabpanel",
    "aria-labelledby": "start-tab",
    tabindex: "0"
};
const _hoisted_11 = { class: "d-flex justify-content-center" };
const _hoisted_12 = ["href"];
const _hoisted_13 = {
    class: "tab-pane fade",
    id: "load",
    role: "tabpanel",
    "aria-labelledby": "load-tab",
    tabindex: "0"
};
const _hoisted_14 = {
    key: 0,
    class: "alert alert-danger",
    role: "alert"
};
const _hoisted_15 = { class: "form-floating mb-3" };
const _hoisted_16 = { for: "configurationId" };
const _hoisted_17 = { class: "d-flex justify-content-center" };
const _hoisted_18 = {
    type: "submit",
    class: "btn btn-primary"
};
const _hoisted_19 = {
    key: 0,
    class: "mt-5 small"
};
import { cssStyleSheetLoader } from '@/Configurator/Composables/cssStyleSheetLoader';
import ConfiguratorLayout from '@/Configurator/Layouts/ConfiguratorLayout.vue';
import { router, usePage } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { observeDOMChanges, sendHeight } from '../Composables/iframeHeightCalculator';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfiguratorStart',
    props: {
        tenantId: String,
        cssFileUrl: {
            type: String,
            default: null
        },
        sessionId: String
    },
    setup(__props) {
        const { t } = useI18n();
        const props = __props;
        let { loadCssStyleSheet } = cssStyleSheetLoader();
        const flash = usePage().props.flash;
        const user = usePage().props.auth.user;
        const currentUrl = ref(`${window.location.origin}${window.location.pathname}`);
        const configurationExternalId = ref('');
        onMounted(() => {
            if (props.cssFileUrl) {
                loadCssStyleSheet(props.cssFileUrl);
            }
            sendHeight();
            observeDOMChanges();
        });
        function loadConfiguration() {
            router.post(route('configurator.loadConfiguration'), {
                tenantId: props.tenantId,
                configurationId: configurationExternalId.value
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ConfiguratorLayout, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("ul", _hoisted_4, [
                                    _createElementVNode("li", _hoisted_5, [
                                        _createElementVNode("button", _hoisted_6, _toDisplayString(_unref(t)('Neue Konfiguration')), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_7, [
                                        _createElementVNode("button", _hoisted_8, _toDisplayString(_unref(t)('Konfiguration laden')), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("a", {
                                                href: currentUrl.value + '?newConfiguration=1',
                                                class: "btn btn-primary"
                                            }, _toDisplayString(_unref(t)('Konfiguration starten')), 9, _hoisted_12)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(loadConfiguration, ["prevent"])
                                        }, [
                                            (_unref(flash).error)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(flash).error), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control bg-white",
                                                    id: "configurationId",
                                                    placeholder: "Konfigurations-ID",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((configurationExternalId).value = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, configurationExternalId.value]
                                                ]),
                                                _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(t)('Konfigurations-ID')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("button", _hoisted_18, _toDisplayString(_unref(t)('Konfiguration laden')), 1)
                                            ])
                                        ], 32)
                                    ])
                                ])
                            ])
                        ]),
                        (_unref(user) && !_unref(user).isCustomer)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(props.sessionId), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }));
        };
    }
});
